import { render, staticRenderFns } from "./DestinationDialog.vue?vue&type=template&id=65cbd4c6"
import script from "./DestinationDialog.vue?vue&type=script&lang=js"
export * from "./DestinationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports